import clsx from 'clsx';

import { OrderTypeChip } from 'components/order-type-chip';
import { TurboTag } from 'features/order/geoqueues/components';
import { useAutoAcceptKanbanCard } from './useAutoAcceptKanbanCard';
import { AuditableChip } from 'components/main-kanban-card/components';

import FilledCookIcon from 'assets/images/filled_cook.svg';

import makeClasses from './AutoAcceptKanbanCard.style';

import type { OrderResponseFromStatusV2 } from 'business/shared/infra';

export function AutoAcceptKanbanCard({ order }: Props) {
  const {
    id: orderId,
    store_name: storeName,
    special_order: specialOrder,
  } = order;

  const {
    showStoreName,
    isTurbo,
    openDetail,
    newOrderText,
  } = useAutoAcceptKanbanCard({
    orderId,
    storeName,
    specialOrder: specialOrder ?? [],
  });

  const _classes = makeClasses();

  return (
    <article
      data-order-id={orderId}
      data-has-turbotag={isTurbo}
      className={clsx(_classes.article)}
    >
      {isTurbo && <TurboTag parentClass={_classes.turboTag} />}
      <header>
        <OrderTypeChip orderType={'normal'} />
        <AuditableChip show={order.is_auditable} />
      </header>
      <main onClick={openDetail}>
        <section className={_classes.section}>
          <div className={_classes.orderInfo}>
            <span className={_classes.orderId}>{`ID: ${orderId}`}</span>
            {showStoreName && (
              <span className={_classes.storeName}>{storeName}</span>
            )}
          </div>
          <div className={_classes.detail}>
            <img alt='cooking_icon' src={FilledCookIcon} />
            <span>{newOrderText}</span>
          </div>
        </section>
      </main>
    </article>
  );
}

interface Props {
  order: OrderResponseFromStatusV2;
}
